import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import baseTheme from "@insite/mobius/globals/baseTheme";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    mobileMenuHidden: HiddenProps;
    mainNav: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            flex: 0 0 100%;
            margin: 0 auto;
            flex-wrap: wrap;
            align-items: center;
            ${({ theme }) => {
                const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                return breakpointMediaQueries(theme, [
                    css`
                        max-width: ${maxWidths[0]}px;
                        flex-wrap: wrap;
                        padding: 10px 0 0 0;
                    `,
                    css`
                        max-width: ${maxWidths[1]}px;
                        flex-wrap: wrap;
                        padding: 10px 0 0 0;
                    `,
                    css`
                        max-width: ${maxWidths[2]}px;
                        flex-wrap: wrap;
                        padding: 10px 0 0 0;
                    `,
                    css`
                        max-width: ${maxWidths[3]}px;
                        padding: 0 40px;
                    `,
                    css`
                        max-width: ${maxWidths[4]}px;
                        padding: 0 40px;
                    `,
                ]);
            }}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            padding: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                            > div[class^="Wrapper"] {
                                > div {
                                    max-width: 100%;
                                    text-align: center;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    mobileMenuHidden: {
        above: "md",
        css: css`
            width: 100%;
        `,
    },
    mainNav: {
        css: css`
            text-align: left;
            padding: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                            width: 100%;
                            background: #6C757D;
                            margin-top: 10px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container} data-test-selector="test_logo_link_search_container">
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            <Zone contentId={id} zoneName="Logo" />
        </StyledWrapper>
        <Hidden below="lg" {...logoLinksSearchStyles.mainNav}>
            <Zone contentId={id} zoneName="MainNavigation" />
        </Hidden>
        <Hidden {...logoLinksSearchStyles.mobileMenuHidden}>
            <Zone contentId={id} zoneName="MobileNavigation" />
        </Hidden>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper} data-test-selector="search-Menu-Wrapper">
            <Hidden {...logoLinksSearchStyles.linkListHidden}>
                <Zone contentId={id} zoneName="LinkList" />
            </Hidden>
            <Zone contentId={id} zoneName="Search" />
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
